/**
 * SentryStatusBanner Component
 * 
 * Shows a non-intrusive banner when Sentry error tracking is disabled
 * (no DSN provided).
 */

import React, { useState } from 'react';
import { AlertCircle, X } from 'lucide-react';
import { IS_SENTRY_ENABLED } from '@/app/utils/errorTracking';
import { useLanguage } from '@/app/contexts/LanguageContext';

export function SentryStatusBanner() {
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(true);

  // Don't show banner when Sentry is enabled
  if (IS_SENTRY_ENABLED || !isVisible) {
    return null;
  }

  return (
    <div 
      className="fixed bottom-4 left-4 bg-gray-50 border border-gray-200 rounded-lg px-4 py-2 shadow-md max-w-md" 
      style={{ zIndex: 50 }}
    >
      <div className="flex items-start gap-3">
        <div className="flex items-start gap-2 text-gray-700 text-sm flex-1">
          <AlertCircle className="w-4 h-4 flex-shrink-0 mt-0.5" />
          <div>
            <span className="font-medium block">
              {t('sentry.status.banner.title')}
            </span>
            <span className="text-gray-500 text-xs">
              {t('sentry.status.banner.desc')}
            </span>
          </div>
        </div>
        <button
          onClick={() => setIsVisible(false)}
          className="text-gray-400 hover:text-gray-600 transition-colors p-1 hover:bg-gray-100 rounded"
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
